import Model from './Model'

export default class Settings extends Model {
    // Set the resource route of the model
    resource() {
        return 'settings'
    }
}
